import { IEmployee } from '@/common/integrations/menhir/employee/employee/employee.types';
import { ICompany } from '@/common/types/company';
import { User } from 'configcat-js';

const { temporaryClient, permanentClient } = loadConfigCatClients();

function loadConfigCatClients() {
  if (process.env.EXPO_PUBLIC_MOCK || process.env.NODE_ENV === 'test') {
    const mockClient = require('./feature-flag.mocks');
    return mockClient;
  } else {
    const clientModule = require('./feature-flag.client');
    return clientModule;
  }
}

function setDefaultUser(employee: IEmployee, company: ICompany) {
  const user = new User(
    `company_person:${employee.id}`,
    employee.email,
    undefined,
    {
      company_id: employee.companyId,
      market: company.market.slug,
    }
  );
  temporaryClient.setDefaultUser(user);
  permanentClient.setDefaultUser(user);
}

function cleanDefaultUser() {
  temporaryClient.clearDefaultUser();
  permanentClient.clearDefaultUser();
}

async function refreshTemporaryValues() {
  return temporaryClient.forceRefreshAsync();
}

async function refreshPermanentValues() {
  return permanentClient.forceRefreshAsync();
}

async function getAllTemporaryValues(user?: User) {
  return temporaryClient.getAllValuesAsync(user);
}

async function getAllPermanentValues(user?: User) {
  return permanentClient.getAllValuesAsync(user);
}

export const FeatureFlagService = {
  setDefaultUser,
  cleanDefaultUser,
  refreshTemporaryValues,
  refreshPermanentValues,
  getAllTemporaryValues,
  getAllPermanentValues,
};
